<template>
  <div class="badge-pill text-center">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "BadgePill",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.badge-pill {
  background-color: $color-light;
  padding: $spacer * 0.3 $spacer $spacer * 0.2 $spacer;
}
</style>
